<template>
  <div>
    <v-app>
      <b-form @submit.stop.prevent="formOnsubmit">
        <!-- Input Date -->
        <b-form-group
          id="input-group-date"
          label="Tanggal:"
          label-for="input-date"
        >
          <v-dialog
            ref="dialogDate"
            v-model="modal2"
            :return-value.sync="form.date"
            persistent
            width="350px"
          >
            <template v-slot:activator="{ on, attrs }">
              <b-form-input
                readonly
                v-bind="attrs"
                v-on="on"
                id="input-trigger-modal-date"
                v-model="form.date"
              >
              </b-form-input>
            </template>

            <v-date-picker v-if="modal2" locale="id" v-model="form.date">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal2 = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialogDate.save(form.date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <small class="text-danger">{{ error.date }}</small>
        </b-form-group>

        <!-- Input Due Date -->
        <b-form-group
          id="input-group-due-date"
          label="Tanggal Jatuh Tempo:"
          label-for="input-due-date"
        >
          <v-dialog
            ref="dialog"
            v-model="modal3"
            :return-value.sync="form.due_date"
            persistent
            width="350px"
          >
            <template v-slot:activator="{ on, attrs }">
              <b-form-input
                readonly
                v-bind="attrs"
                v-on="on"
                id="input-trigger-modal-date"
                v-model="form.due_date"
              >
              </b-form-input>
            </template>

            <v-date-picker v-if="modal3" locale="id" v-model="form.due_date">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal3 = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog.save(form.due_date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <small class="text-danger">{{ error.due_date }}</small>
        </b-form-group>

        <!-- Name input -->
        <b-form-group
          id="input-group-po-no"
          label="Invoice No.:"
          label-for="input-po-no"
        >
          <b-form-input
            id="input-po-no"
            v-model="form.po_no"
            placeholder="Invoice No."
          ></b-form-input>
          <small class="text-danger">{{ error.po_no }}</small>
        </b-form-group>

        <!-- Name input -->
        <b-form-group id="input-group-vendor">
          <label for="input-vendor">Kepada:</label>
          <treeselect
            v-model="form.vendor_id"
            :multiple="false"
            :options="vendors"
            @select="setVendor"
          />
          <small class="text-danger">{{ error.vendor_id }}</small>
        </b-form-group>

        <!-- Input Opening Sentence -->
        <b-form-group id="input-group-opening-sentence">
          <label for="input-opening-sentence">Kalimat Pembuka:</label>
          <!-- <b-form-textarea
            id="input-opening-sentence"
            v-model="form.opening_sentence"
            rows="3"
            placeholder="Kalimat Pembuka"
            @keyup="setOpeningSentence"
          ></b-form-textarea> -->
          <div class="document-editor">
            <ckeditor
              id="input-opening-sentence"
              :editor="editor"
              :config="editorConfig"
              @ready="onReady"
              v-model="localOpeningSentence"
            ></ckeditor>
          </div>
          <small class="text-danger">{{ error.opening_sentence }}</small>
        </b-form-group>

        <!-- Input Batch No -->
        <!-- <b-form-group id="input-group-batch-no">
          <label for="input-vendor">Item</label>
          <div class="row">
            <div class="col-md-3">
              <b-form-input
                id="input-batch-no"
                v-model="medicine_collection_form.item"
                placeholder="Nama Item"
              >
              </b-form-input>
            </div>
            <div class="col-md-3">
              <b-form-input
                id="input-quantity-batch"
                v-model="medicine_collection_form.quantity"
                placeholder="Kuantitas"
              >
              </b-form-input>
            </div>
            <div class="col-md-3">
              <b-form-input
                id="input-price-batch"
                v-model="formatedSalesPrice"
                placeholder="Harga"
              >
              </b-form-input>
            </div>
            <div class="col-md-3">
              <b-button
                size="sm"
                class="btn-info"
                v-b-tooltip.hover
                title="Tambah Batch"
                type="button"
                @click="setItem"
                v-if="
                  medicine_collection_form.quantity != '' &&
                  medicine_collection_form.price != '' &&
                  medicine_collection_form.item != ''
                "
                ><i class="fas fa-plus px-0"></i
              ></b-button>
              <b-button
                size="sm"
                class="btn-info"
                type="button"
                @click="setItem"
                disabled
                v-if="
                  medicine_collection_form.quantity == '' ||
                  medicine_collection_form.price == '' ||
                  medicine_collection_form.item == ''
                "
                ><i class="fas fa-plus px-0"></i
              ></b-button>
            </div>
          </div>
          <small class="text-danger">{{ error.items }}</small>
        </b-form-group> -->

        <div class="row">
          <div class="col-12">
            <b-button
              block
              class="btn-info"
              variant="info"
              size="sm"
              @click="$bvModal.show('modal-medicine')"
              >Pilih Obat/Alkes</b-button
            >
          </div>
        </div>
        <!-- <div class="bg-light mt-4"> -->
        <table class="table table-striped table-bordered mt-4">
          <tr>
            <th>No</th>
            <th>Item</th>
            <th>Merk</th>
            <th>Harga per unit</th>
            <th>Jumlah</th>
            <th>Satuan</th>
            <th>Diskon</th>
            <th>Total</th>
            <th>Aksi</th>
          </tr>
          <tr v-for="(mdc, index) in medicine_collection" :key="mdc.id">
            <td>{{ index + 1 }}</td>
            <td>{{ mdc.name }}</td>
            <td>{{ mdc.brand }}</td>
            <td>{{ mdc.price }}</td>
            <td>{{ mdc.quantity }}</td>
            <td>{{ mdc.uom }}</td>
            <td>
              {{
                mdc.is_percent == 1
                  ? `${mdc.discount_amount}% `
                  : `Rp ${mdc.discount_amount}`
              }}
            </td>
            <td>{{ mdc.total_price }}</td>
            <td>
              <b-button
                size="sm"
                class="btn-info"
                v-b-tooltip.hover
                title="Ubah Obat/Alkes"
                type="button"
                @click="editItem(index)"
                ><i class="fas fa-edit px-0"></i
              ></b-button>
              <b-button
                size="sm"
                class="btn-danger ml-2"
                v-b-tooltip.hover
                title="Hapus Obat/Alkes"
                type="button"
                @click="removeItem(mdc.item)"
                ><i class="fas fa-trash px-0"></i
              ></b-button>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="text-right">Subtotal</td>
            <td>{{ subtotal() }}</td>
          </tr>
          <tr>
            <td colspan="6" class="text-right">Diskon {{ form.discount }}%</td>
            <td>{{ discount() }}</td>
          </tr>
          <tr>
            <td colspan="6" class="text-right">Total</td>
            <td>{{ total() }}</td>
          </tr>
        </table>
        <!-- </div> -->

        <!-- Input Discount -->
        <b-form-group
          id="input-group-discount"
          label="Diskon(%):"
          label-for="input-discount"
        >
          <b-form-input
            id="input-discount"
            v-model="form.discount"
            placeholder="Diskon"
          >
          </b-form-input>
          <small class="text-danger">{{ error.discount }}</small>
        </b-form-group>

        <!-- Input PPN -->
        <!-- <b-form-group
          id="input-group-ppn"
          label="PPN(%):"
          label-for="input-ppn"
        >
          <b-form-input id="input-ppn" v-model="form.ppn" placeholder="PPN">
          </b-form-input>
          <small class="text-danger">{{ error.ppn }}</small>
        </b-form-group> -->

        <!-- Input Closing Sentence -->
        <b-form-group id="input-group-closing-sentence">
          <label for="input-closing-sentence">Kalimat Penutup:</label>
          <!-- <b-form-textarea
            id="input-closing-sentence"
            v-model="form.closing_sentence"
            rows="3"
            placeholder="Kalimat Penutup"
          ></b-form-textarea> -->
          <div class="document-editor">
            <ckeditor
              id="input-closing-sentence"
              :editor="editor"
              :config="editorConfig"
              @ready="onReady"
              v-model="form.closing_sentence"
            ></ckeditor>
          </div>
          <small class="text-danger">{{ error.closing_sentence }}</small>
        </b-form-group>

        <div class="row">
          <div class="col-12 col-md-6">
            <b-form-group
              id="input-group-pic-name"
              label="Nama Kepala Depo Farmasi:"
              label-for="input-pic-name"
            >
              <b-form-input
                id="input-pic-name"
                v-model="form.pic_name"
                placeholder="Nama Kepala Depo Farmasi"
              ></b-form-input>
              <small class="text-danger">{{ error.pic_name }}</small>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group id="input-group-pic-signature">
              <label for="input-pic-signature">TTD: </label>
              <b-form-file
                v-model="form.pic_signature"
                placeholder="Upload TTD"
                drop-placeholder="Drop file here..."
                @change="onFileUpload"
              ></b-form-file>
              <small class="text-danger">{{ error.pic_signature }}</small>
            </b-form-group>
            <div class="signature mb-4">
              <img
                :src="
                  uploadedImageUrl == '' ? form.pic_signature : uploadedImageUrl
                "
              />
            </div>
          </div>
        </div>
        <!-- 
        <div class="row">
          <div class="col-12 col-md-6">
            <b-form-group
              id="input-group-submitting-name"
              label="Nama Yang Menyerahkan:"
              label-for="input-submitting-name"
            >
              <b-form-input
                id="input-submitting-name"
                v-model="form.submitting_name"
                placeholder="Nama Yang Menyerahkan"
              ></b-form-input>
              <small class="text-danger">{{ error.submitting_name }}</small>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group id="input-group-submitting-signature">
              <label for="input-submitting-signature">TTD: </label>
              <b-form-file
                v-model="form.submitting_signature"
                placeholder="Upload TTD"
                drop-placeholder="Drop file here..."
                @change="onFileUpload2"
              ></b-form-file>
              <small class="text-danger">{{ error.submitting_signature }}</small>
            </b-form-group>
            <div class="signature mb-4">
              <img
                :src="
                  uploadedImageUrl2 == '' ? form.submitting_signature : uploadedImageUrl2
                "
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <b-form-group
              id="input-group-recipient-name"
              label="Nama Yang Menerima:"
              label-for="input-recipient-name"
            >
              <b-form-input
                id="input-recipient-name"
                v-model="form.recipient_name"
                placeholder="Nama Yang Menerima"
              ></b-form-input>
              <small class="text-danger">{{ error.recipient_name }}</small>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group id="input-group-recipient-signature">
              <label for="input-recipient-signature">TTD: </label>
              <b-form-file
                v-model="form.recipient_signature"
                placeholder="Upload TTD"
                drop-placeholder="Drop file here..."
                @change="onFileUpload3"
              ></b-form-file>
              <small class="text-danger">{{ error.recipient_signature }}</small>
            </b-form-group>
            <div class="signature mb-4">
              <img
                :src="
                  uploadedImageUrl3 == '' ? form.recipient_signature : uploadedImageUrl3
                "
              />
            </div>
          </div>
        </div> -->

        <!-- Submit & Cancel button -->
        <b-button type="submit" variant="primary">Simpan</b-button>
        <b-button
          type="button"
          class="ml-2"
          variant="default"
          @click="$router.push('/purchase-orders')"
        >
          Batal
        </b-button>
      </b-form>
    </v-app>

    <ModalMedicine
      @chosenMedicine="setItem"
      :selectedItem="medicine_collection"
      :checkbox="false"
    />

    <b-modal id="modal-form-item" hide-footer title="Form Item">
      <b-form>
        <!-- <div class="d-block text-center"> -->
        <b-form-group
          id="input-group-item"
          label="Item:"
          label-for="input-item"
        >
          <b-form-input
            id="input-item"
            v-model="medicine_collection_form.name"
            placeholder="Item"
            disabled
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-brand"
          label="Merk:"
          label-for="input-brand"
        >
          <b-form-input
            id="input-brand"
            v-model="medicine_collection_form.brand"
            placeholder="Merk"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-price"
          label="Harga per unit:"
          label-for="input-price"
        >
          <b-form-input
            id="input-price"
            v-model="formatedSalesPrice"
            placeholder="Harga per unit"
            @keyup="setSalesPrice"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-quantity"
          label="Jumlah:"
          label-for="input-quantity"
        >
          <b-form-input
            id="input-quantity"
            v-model="medicine_collection_form.quantity"
            placeholder="Jumlah"
            @keyup="setSalesPrice"
          ></b-form-input>
        </b-form-group>

        <label for="is_percent">Diskon</label>
        <b-form-group id="input-group-discount-type">
          <b-form-select
            v-model="medicine_collection_form.is_percent"
            class="mb-3"
            @select="setSalesPrice"
          >
            <b-form-select-option :value="''">Tipe Diskon</b-form-select-option>
            <b-form-select-option value="1">Persen</b-form-select-option>
            <b-form-select-option value="0">Rupiah</b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-discount-amount"
          label="Jumlah Diskon:"
          label-for="input-discount-amount"
          @keyup="setSalesPrice"
        >
          <b-form-input
            id="input-discount-amount"
            v-model="medicine_collection_form.discount_amount"
            placeholder="Jumlah Diskon"
          ></b-form-input>
        </b-form-group>

        <!-- <b-form-group
          id="input-group-total-price"
          label="Total Harga:"
          label-for="input-total-price"
        >
          <b-form-input
            id="input-total-price"
            v-model="medicine_collection_form.total_price"
            placeholder="Total Harga"
            disabled
          ></b-form-input>
        </b-form-group> -->

        <b-form-group
          id="input-group-uom"
          label="Satuan:"
          label-for="input-uom"
        >
          <b-form-input
            id="input-uom"
            v-model="medicine_collection_form.uom"
            placeholder="Satuan"
          ></b-form-input>
        </b-form-group>

        <!-- </div> -->
        <!-- Submit & Cancel button -->
        <b-button type="button" variant="primary" @click="saveFormItem"
          >Simpan</b-button
        >
        <b-button
          type="button"
          class="ml-2"
          variant="default"
          @click="cancelSaveFormItem"
        >
          Batal
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import ModalMedicine from "@/component/general/ModalMedicine.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  props: {
    form: Object,
    route: String,
    opening_sentence: String,
  },
  components: {
    ModalMedicine,
  },
  data() {
    return {
      localOpeningSentence: this.opening_sentence,
      modal2: false,
      modal3: false,
      // Error
      error: {
        date: "",
        due_date: "",
        po_no: "",
        vendor_id: "",
        vendor_name: "",
        items: "",
        discount: "",
        ppn: "",
        opening_sentence: "",
        closing_sentence: "",
      },
      // other
      vendors: [],
      medicine_collection: [],
      medicine_collection_str: [],
      medicine_collection_form: {
        medicine_id: "",
        name: "",
        quantity: "",
        price: "",
        total_price: "",
        brand: "",
        uom: "",
        id_percent: 0,
        discount_amount: 0,
      },
      // ckeditor
      editor: DecoupledEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "fontFamily",
          "fontSize",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "|",
          "indent",
          "outdent",
          "|",
          "alignment",
          "|",
          "link",
          "blockQuote",
          "bulletedList",
          "numberedList",
          "|",
          "insertTable",
          "|",
          "mediaEmbed",
          "|",
          "undo",
          "redo",
        ],
        alignment: {
          options: ["left", "right", "center", "justify"],
        },
        table: {
          toolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
      },
      tester: "",
      opening_sentence_write: false,
      purposeFormItem: "addItem", // addItem or editItem
      indexFormItem: null,
      uploadedImageUrl: "",
      uploadedImageUrl2: "",
      uploadedImageUrl3: "",
    };
  },

  methods: {
    setSalesPrice() {},
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },

    onFileUpload(evt) {
      this.uploadedImageUrl = URL.createObjectURL(evt.target.files[0]);
      this.form.pic_signature = evt.target.files[0];
    },
    onFileUpload2(evt) {
      this.uploadedImageUrl2 = URL.createObjectURL(evt.target.files[0]);
      this.form.submitting_signature = evt.target.files[0];
    },
    onFileUpload3(evt) {
      this.uploadedImageUrl3 = URL.createObjectURL(evt.target.files[0]);
      this.form.recipient_signature = evt.target.files[0];
    },

    subtotal() {
      let subtotal = 0;
      this.medicine_collection.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      return subtotal.toLocaleString("id-ID");
    },
    discount() {
      let subtotal = 0;
      this.medicine_collection.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      let discount = (subtotal * this.form.discount) / 100;
      return discount.toLocaleString("id-ID");
    },
    total() {
      let subtotal = 0;
      this.medicine_collection.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      let total = subtotal - (subtotal * this.form.discount) / 100;
      return total.toLocaleString("id-ID");
    },

    setOpeningSentence() {
      console.log(this.opening_sentence_write);
      this.opening_sentence_write = true;
    },

    async getVendorOption() {
      let response = await module.setTreeSelect("vendors");
      console.log("vendor option", response);
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.vendors = response.data;
        this.vendors.unshift({
          label: "Pilih Supplier",
          id: "",
          isDisabled: true,
        });
      }
    },

    removeItem($item) {
      let a;
      for (a = 0; a < this.medicine_collection.length; a++) {
        if (this.medicine_collection[a].item == $item) {
          this.medicine_collection.splice(a, 1);
        }
      }
    },

    setVendor(evt) {
      console.log("evt", evt);
      this.form.vendor_id = evt.id;
      this.form.vendor_name = evt.label;
      // if(this.opening_sentence_write == false){
      //   this.form.opening_sentence = `Sehubungan dengan surat penawaran harga (quotation) ${evt.label}, maka kami ingin memesan produk sebagai berikut :`
      // }
      // this.form.opening_sentence = `Sehubungan dengan surat penawaran harga (quotation) ${evt.label}, maka kami ingin memesan produk sebagai berikut :`
    },

    resetFormItem() {
      this.medicine_collection_form.medicine_id = "";
      this.medicine_collection_form.name = "";
      this.medicine_collection_form.quantity = "";
      this.medicine_collection_form.price = "";
      this.medicine_collection_form.total_price = "";
      this.medicine_collection_form.brand = "";
      this.medicine_collection_form.uom = "";
      this.medicine_collection_form.is_percent = 0;
      this.medicine_collection_form.discount_amount = 0;
    },
    async setItem(value) {
      let price = parseFloat(value.sales_price);
      this.purposeFormItem = "addItem";
      //cari apakah item sudah ada di list
      let found = this.medicine_collection.find(
        (element) => element.medicine_id == value.id
      );

      if (found) {
        Swal.fire({
          title: "Gagal",
          text: "Obat/Alkes sudah dipilih",
          icon: "warning",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      this.medicine_collection_form.medicine_id = value.id;
      this.medicine_collection_form.name = value.name;
      this.medicine_collection_form.price = price.toLocaleString("id-ID");
      this.medicine_collection_form.uom = value.uom_name;

      this.$bvModal.show("modal-form-item");
    },

    saveFormItem() {
      if (this.medicine_collection_form.brand == "") {
        Swal.fire({
          title: "Gagal",
          text: "Merk harus diisi",
          icon: "warning",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      if (this.purposeFormItem == "addItem") {
        let discount_amount = 0;
        let total_price =
          parseInt(this.medicine_collection_form.price.replace(/\D/g, ""), 10) *
          parseInt(this.medicine_collection_form.quantity, 10);
        if (this.medicine_collection_form.discount_amount > 0) {
          if (this.medicine_collection_form.is_percent == 1) {
            discount_amount =
              this.medicine_collection_form.discount_amount / 100;
            total_price = total_price - total_price * discount_amount;
          } else {
            total_price =
              total_price - this.medicine_collection_form.discount_amount;
          }
        }

        this.medicine_collection_form.total_price =
          total_price.toLocaleString("id-ID");

        this.medicine_collection.push({ ...this.medicine_collection_form });
        this.resetFormItem();
        Swal.fire({
          title: "Berhasil",
          text: "Obat/Alkes berhasil ditambahkan",
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.$bvModal.hide("modal-form-item");
      } else if (this.purposeFormItem == "editItem") {
        let discount_amount = 0;
        let total_price =
          parseInt(this.medicine_collection_form.price.replace(/\D/g, ""), 10) *
          parseInt(this.medicine_collection_form.quantity, 10);

        if (this.medicine_collection_form.discount_amount > 0) {
          if (this.medicine_collection_form.is_percent == 1) {
            discount_amount =
              this.medicine_collection_form.discount_amount / 100;
            total_price = total_price - total_price * discount_amount;
          } else {
            total_price =
              total_price - this.medicine_collection_form.discount_amount;
          }
        }

        this.medicine_collection_form.total_price =
          total_price.toLocaleString("id-ID");

        // this.$set(
        //   this.medicine_collection,
        //   this.indexFormItem,
        //   this.medicine_collection_form
        // );
        this.medicine_collection[this.indexFormItem] = {
          ...this.medicine_collection_form,
        };
        this.resetFormItem();
        Swal.fire({
          title: "Berhasil",
          text: "Obat/Alkes berhasil diubah",
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.$bvModal.hide("modal-form-item");
        this.purposeFormItem = "addItem";
      }
    },
    cancelSaveFormItem() {
      this.resetFormItem();
      this.$bvModal.hide("modal-form-item");
      this.purposeFormItem = "addItem";
    },
    editItem(index) {
      this.purposeFormItem = "editItem";
      this.indexFormItem = index;
      let item = this.medicine_collection[index];
      this.medicine_collection_form.medicine_id = item.medicine_id;
      this.medicine_collection_form.name = item.name;
      this.medicine_collection_form.price = item.price;
      this.medicine_collection_form.quantity = item.quantity;
      this.medicine_collection_form.total_price = item.total_price;
      this.medicine_collection_form.brand = item.brand;
      this.medicine_collection_form.uom = item.uom;
      this.medicine_collection_form.discount_amount = item.discount_amount;
      this.medicine_collection_form.is_percent = item.is_percent;

      this.$bvModal.show("modal-form-item");
    },

    async formOnsubmit() {
      if (this.medicine_collection.length > 0) {
        this.medicine_collection_str = await JSON.stringify(
          this.medicine_collection
        );
        this.form.items = await this.medicine_collection_str;
        this.form.opening_sentence = this.localOpeningSentence;

        let formData = new FormData();
        for (const [key, value] of Object.entries(this.form)) {
          formData.append(key, value);
        }
        // Make Request
        let response = await module.submit(formData, this.route);
        // Check Response
        if (response.state == "error") {
          // Validation Error
          this.error = validation.setValidationError(
            this.error,
            response.error.errors
          );
        } else {
          // Success
          Swal.fire(
            response.success.title,
            response.success.message,
            "success"
          );
          this.$router.push("/purchase-orders");
        }
      } else if (this.medicine_collection.length == 0) {
        Swal.fire({
          title: "Gagal",
          text: "Item tidak boleh kosong",
          icon: "warning",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.error.items = "Item tidak boleh kosong";
      }
    },
  },

  mounted() {
    this.getVendorOption();

    this.medicine_collection = this.form.items_display;
  },

  computed: {
    formatedSalesPrice: {
      set(newValue) {
        newValue = parseInt(newValue.replace(/\D/g, ""), 10);
        if (!Number.isNaN(newValue)) {
          this.medicine_collection_form.price =
            newValue.toLocaleString("id-ID");
        } else {
          this.medicine_collection_form.price = "";
        }
      },
      get() {
        return this.medicine_collection_form.price;
      },
    },
  },

  watch: {
    opening_sentence(newVal) {
      this.localOpeningSentence = newVal;
    },
    localOpeningSentence(newVal) {
      // kalau mau sinkron balik ke parent form, bisa emit
      this.$emit("update:opening_sentence", newVal);
    },
  },
};
</script>

<style scoped>
.signature {
  height: 200px;
  width: 200px;
}

.signature img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
</style>